import React from 'react';

const redGradient = '#dc2626';
const cardBg = '#111';
const cardBorder = '#1f1f1f';
const cardBorderSelected = 'rgba(220,38,38,0.4)';

function SongCard({ item, isSelected, onSelect, onEdit, onDelete, viewMode }) {
  const formatDuration = (seconds) => {
    if (!seconds) return '--:--';
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const formatPlayCount = (count) => {
    if (!count) return '0';
    if (count >= 1000000) return `${(count / 1000000).toFixed(1)}M`;
    if (count >= 1000) return `${(count / 1000).toFixed(1)}K`;
    return count.toString();
  };

  const MusicIcon = () => (
    <svg className="w-6 h-6 text-white opacity-80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
    </svg>
  );

  if (viewMode === 'list') {
    return (
      <div
        className="flex items-center justify-between p-4 rounded-xl transition-all"
        style={{ background: cardBg, border: `1px solid ${isSelected ? cardBorderSelected : cardBorder}` }}
      >
        <div className="flex items-center gap-4 min-w-0">
          <input type="checkbox" checked={isSelected} onChange={onSelect} className="w-4 h-4 rounded flex-shrink-0" style={{ accentColor: '#dc2626' }} />
          <div className="flex items-center gap-3 min-w-0">
            <div className="w-10 h-10 rounded-lg flex-shrink-0 flex items-center justify-center" style={{ background: redGradient }}>
              <MusicIcon />
            </div>
            <div className="min-w-0">
              <h3 className="font-bold text-white text-sm truncate">{item.title}</h3>
              <div className="flex items-center gap-2 mt-0.5">
                <span className="text-xs truncate" style={{ color: '#9ca3af' }}>{item.Artist?.name || 'Unknown Artist'}</span>
                {item.album?.title && <span className="text-xs truncate hidden md:block" style={{ color: '#6b7280' }}>• {item.album.title}</span>}
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-5 flex-shrink-0">
          <div className="hidden md:flex items-center gap-5">
            <span className="text-xs font-mono" style={{ color: '#9ca3af' }}>{formatDuration(item.duration_seconds)}</span>
            <span className="text-xs" style={{ color: '#6b7280' }}>{formatPlayCount(item.play_count)} plays</span>
            {item.genre && (
              <span className="text-xs px-2 py-0.5 rounded font-medium" style={{ background: 'rgba(220,38,38,0.1)', color: '#f87171', border: '1px solid rgba(220,38,38,0.15)' }}>
                {item.genre}
              </span>
            )}
          </div>
          <div className="flex gap-2">
            <button onClick={onEdit} className="px-3 py-1.5 rounded-lg text-xs font-medium text-white" style={{ background: '#1a1a1a', border: '1px solid #2a2a2a' }}>Edit</button>
            <button onClick={onDelete} className="px-3 py-1.5 rounded-lg text-xs font-medium" style={{ background: 'rgba(220,38,38,0.1)', color: '#f87171', border: '1px solid rgba(220,38,38,0.2)' }}>Delete</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="relative rounded-xl p-5 transition-all group"
      style={{ background: cardBg, border: `1px solid ${isSelected ? cardBorderSelected : cardBorder}` }}
    >
      <div className="absolute top-3 left-3">
        <input type="checkbox" checked={isSelected} onChange={onSelect} className="w-4 h-4 rounded" style={{ accentColor: '#dc2626' }} />
      </div>

      <div className="relative aspect-square rounded-xl mb-4 flex items-center justify-center" style={{ background: redGradient }}>
        <svg className="w-12 h-12 text-white opacity-70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
        </svg>
        <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded text-xs font-mono font-bold text-white" style={{ background: 'rgba(0,0,0,0.7)' }}>
          {formatDuration(item.duration_seconds)}
        </div>
      </div>

      <h3 className="font-black text-white text-sm truncate mb-1">{item.title}</h3>
      <p className="text-xs truncate mb-1" style={{ color: '#9ca3af' }}>{item.Artist?.name || 'Unknown Artist'}</p>
      {item.album?.title && <p className="text-xs truncate mb-3" style={{ color: '#6b7280' }}>{item.album.title}</p>}

      <div className="flex items-center justify-between mb-4">
        <span className="text-xs" style={{ color: '#6b7280' }}>{formatPlayCount(item.play_count)} plays</span>
        {item.genre && (
          <span className="text-xs px-2 py-0.5 rounded font-medium" style={{ background: 'rgba(220,38,38,0.1)', color: '#f87171', border: '1px solid rgba(220,38,38,0.15)' }}>
            {item.genre}
          </span>
        )}
      </div>

      <div className="flex gap-2">
        <button onClick={onEdit} className="flex-1 py-2 rounded-lg text-xs font-medium text-white" style={{ background: '#1a1a1a', border: '1px solid #2a2a2a' }}>Edit</button>
        <button onClick={onDelete} className="flex-1 py-2 rounded-lg text-xs font-medium" style={{ background: 'rgba(220,38,38,0.1)', color: '#f87171', border: '1px solid rgba(220,38,38,0.2)' }}>Delete</button>
      </div>
    </div>
  );
}

export default SongCard;